'use strict';

import {
  addClassToElement,
  classes,
  removeClassToElement
} from '@jspartials/class-list-utils';
import { listenDOMEvent } from '@jspartials/dom-api-utils';

// Selectors
const selector = {
  link: '.js-faq-link',
  subLink: '.js-faq-sub-link',
  articleTitle: '.js-article-title',
  articleQuestion: '.js-article-question'
};

// Elements
const element = {
  links: document.querySelectorAll(selector.link) || [],
  subLinks: document.querySelectorAll(selector.subLink) || [],
  articleTitles: document.querySelectorAll(selector.articleTitle) || [],
  articleQuestions: document.querySelectorAll(selector.articleQuestion) || []
};

// Functions

/**
 * Listen to links click events
 * @returns {void}
 */
const listenLinks = () => {
  element.links.forEach((link) => {
    listenDOMEvent(link, 'click', () => clickOnLink(link));
  });

  element.subLinks.forEach((link) => {
    listenDOMEvent(link, 'click', () => clickOnSubLink(link));
  });
};

/**
 * Clear all links selected state
 * @returns {void}
 */
const clearLinks = () => {
  element.links.forEach((item) => {
    removeClassToElement(item, classes.is.selected);
  });
};

/**
 * Clear all sub links selected state
 * @returns {void}
 */
const clearSubLinks = () => {
  element.subLinks.forEach((item) => {
    removeClassToElement(item, classes.is.selected);
  });
};

/**
 * Click on link
 * @param {HTMLElement} link
 * @returns {void}
 */
const clickOnLink = (link) => {
  clearLinks();
  markLinkAsSelected(link);
  goToTarget(link);
};

/**
 * Click on sub link
 * @param {HTMLElement} link
 * @returns {void}
 */
const clickOnSubLink = (link) => {
  clearSubLinks();
  markLinkAsSelected(link);
  goToTarget(link);
};

/**
 * Go to target element
 * @param {HTMLElement} link
 * @returns {void}
 */
const goToTarget = (link) => {
  const targetID = link.dataset.target;
  const targetElement = document.getElementById(targetID);
  if (targetElement) {
    const targetPosition = targetElement.offsetTop - 82;
    scrollToPosition(targetPosition);
  }
};

/**
 * Scroll to position
 * @param {number} position
 * @returns {void}
 */
const scrollToPosition = (position) => {
  window.scrollTo({ top: position, behavior: 'smooth' });
};

/**
 * Mark link as selected
 * @param {HTMLElement} link
 * @returns {void}
 */
const markLinkAsSelected = (link) => {
  addClassToElement(link, classes.is.selected);
};

/**
 * Observe sections (titles + questions)
 * @returns {void}
 */
const observeSections = () => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const id = entry.target.id;
        const mainLink = document.querySelector(
          `${selector.link}[data-target="${id}"]`
        );
        const subLink = document.querySelector(
          `${selector.subLink}[data-target="${id}"]`
        );

        if (mainLink) {
          clearLinks();
          markLinkAsSelected(mainLink);
        }

        if (subLink) {
          clearSubLinks();
          markLinkAsSelected(subLink);
        }
      });
    },
    {
      rootMargin: '0px 0px -80% 0px',
      threshold: 0
    }
  );

  [...element.articleTitles, ...element.articleQuestions].forEach((el) => {
    observer.observe(el);
  });
};

// Document ready
document.addEventListener('DOMContentLoaded', function () {
  listenLinks();
  observeSections();
});
